import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const';

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, {
    path: 'company-settings/notifications',
    name: 'Notifications',
    component: () => import('./pages'),
    meta: {
      allowAnonymous: false,
      isNextAppPage: true,
      ability: {
        subject: USER_SUBJECTS.NOTIFICATIONS,
        action: USER_ACTIONS.READ,
      },
    },
  });
};
